import { defineStore } from "pinia"
import { ref } from "vue"
import { useHelp } from "@/pages/admin/help/composables/useHelp"
import type { HelpMenuItem } from "@/pages/admin/help/types"

export const useHelpStore = defineStore("help", () => {
  const { getMenu } = useHelp()

  const helps = ref<HelpMenuItem[]>([])
  const isLoaded = ref(false)
  let inFlight: Promise<void> | null = null

  async function ensureLoaded(): Promise<void> {
    if (isLoaded.value) return
    if (inFlight) return inFlight

    inFlight = (async () => {
      helps.value = await getMenu()
      isLoaded.value = true
    })()

    try {
      await inFlight
    } finally {
      inFlight = null
    }
  }

  function helpsForRoute(routeName: string): HelpMenuItem[] {
    return helps.value
      .filter((h) => h.isActive && h.routes?.includes(routeName))
      .sort((a, b) => a.displayOrder - b.displayOrder)
  }

  async function reload(): Promise<void> {
    isLoaded.value = false
    inFlight = null
    await ensureLoaded()
  }

  return {
    helps,
    ensureLoaded,
    helpsForRoute,
    reload,
  }
})
